import {Action} from 'redux';

import {Remote} from '../entities';

export enum TRemote {
  FETCH_REMOTES = 'FETCH_REMOTES',
  SET_REMOTES = 'SET_REMOTES',
  SET_REMOTE = 'SET_REMOTE',
  UNSET_REMOTE = 'UNSET_REMOTE',
  SET_PLAYER_ID = 'SET_PLAYER_ID'
}
export interface IFetchRemotes extends Action {
  type: TRemote.FETCH_REMOTES;
  payload: string;
}
export const AFetchRemotes = (payload: string): IFetchRemotes => ({ type: TRemote.FETCH_REMOTES, payload });

export interface ISetRemotes extends Action {
  type: TRemote.SET_REMOTES;
  payload: Remote[];
}
export const ASetRemotes = (payload: Remote[]): ISetRemotes => ({ type: TRemote.SET_REMOTES, payload });

export interface ISetRemote extends Action {
  type: TRemote.SET_REMOTE;
  payload: Remote;
}
export const ASetRemote = (payload: Remote): ISetRemote => ({ type: TRemote.SET_REMOTE, payload });

export interface IUnsetRemote extends Action {
  type: TRemote.UNSET_REMOTE;
}

export const AUnsetRemote = (): IUnsetRemote => ({type: TRemote.UNSET_REMOTE});

export interface ISetPlayerId extends Action {
  type: TRemote.SET_PLAYER_ID;
  payload: Remote;
}
export const ASetPlayerId = (payload: Remote): ISetPlayerId => ({ type: TRemote.SET_PLAYER_ID, payload });
